import React from "react";

function HelpTextContainer() {
  const helpTextHeader = "Hint! You can search by any of the following criteria:";
  const helpTextItems = [
    "Merchant name",
    "Merchant ID (GMID)",
    "Merchant organization number",
    "System ID (Zero ID, Samport ID etc.)",
    "Elixir MID",
    "Partner ID",
  ];

  return (
    <div className="help-text">
      <div>
        <p>{helpTextHeader}</p>
        {helpTextItems.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </div>
    </div>
  );
}

export default HelpTextContainer;
